import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Input.module.css';
export const Input = forwardRef(function Input({ mono = false, className, ...rest }, ref) {
    const classes = [styles.input, mono ? styles.mono : '', className].filter(Boolean).join(' ');
    return _jsx("input", { ref: ref, className: classes, ...rest });
});
//# sourceMappingURL=Input.js.map